// extracted by mini-css-extract-plugin
module.exports = {"card":"UploadCard_card__4YWTs","textBlock":"UploadCard_textBlock__3K7N9","button":"UploadCard_button__ZcFjW","gradient":"UploadCard_gradient__TuS8z"};